import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import PopupMenu2 from "../PopupMenu2/PopupMenu2";
import SortFilterList from "../SortFilterList/SortFilterList";
import { memo } from "react";
import { useCallback } from "react";
import TableCaption from "../TableCaption/TableCaption";

const HeaderLabel = ({ label, label2, children }) => {
  return (
    <>
      <p className="label1">{label}</p>
      {label2 && <p className="label2">{label2}</p>}
      {children ? children : <></>}
    </>
  );
};

const TableHeading = ({
  sortable,
  justifyContent,
  label,
  label2,
  isAscending,
  sortKey,
  keyName,
  handleSort,
  headerLabel,
}) => {
  const styleObj = justifyContent ? { justifyContent } : {};
  return sortable ? (
    <button
      style={styleObj}
      className="header_cell header-custom-button cursor blueTextColor"
      aria-label={!headerLabel ? `Sort by ${label}` : headerLabel}
      onClick={handleSort}
    >
      <HeaderLabel label={label} label2={label2}>
        {" "}
        <img
          src={
            isAscending && sortKey === keyName
              ? sortedIcon
              : !isAscending && sortKey === keyName
                ? sortedAtoz
                : sortKey !== keyName
                  ? unsortedIcon
                  : unsortedIcon
          }
          alt=""
        />{" "}
      </HeaderLabel>
    </button>
  ) : (
    <div style={styleObj} className="header_cell blueTextColor">
      <HeaderLabel label={label} label2={label2} />
    </div>
  );
};

const Table = ({
  data,
  columns,
  tableClass,
  EmptyState,
  EmptyStateBody,
  forBorderClass,
  handleSort,
  sortKey,
  isAscending,
  showColumnsOnly,
  elementToPush,
  forThirdTd,
  single_row,
  classUnrealised,
  isTableLoader,
  justifyContent,
  d,
  name,
  tableCaption = "",
  tableHeaderClass = "",
  setSortingAnnoucement = () => {},
}) => {
  const [isOption4Col, setIsOption4Col] = useState(false);

  const HeaderComp = ({
    pWidth,
    classn,
    index,
    width,
    minWidth,
    sortable,
    isMultipleSort,
    key,
    label,
    label2,
    multiSortBox,
    handleSorting,
    position,
    forArrowCheckComp,
    sortKeyComp,
    justifyContent,
    headerLabel,
  }) => {
    const [namesMenuOpen, setNamesMenuOpen] = useState(false);
    const [parMenuOpen, setParMenuOpen] = useState(false);
    const [unrealMenuOpen, setUnrealMenuOpen] = useState(false);

    const reff = useRef();
    const nameRef = useRef();
    const parRef = useRef();
    const unrealRef = useRef();

    const onClickOutside = useCallback((menu) => {
      switch (menu) {
        case "name":
          setNamesMenuOpen(false);
          break;
        case "par":
          setParMenuOpen(false);
          break;
        case "unreal":
          setUnrealMenuOpen(false);
          break;
        default:
          break;
      }
    }, []);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (nameRef.current && !nameRef.current.contains(event.target)) {
          onClickOutside && onClickOutside("name");
        }
        if (parRef?.current && !parRef?.current?.contains(event.target)) {
          onClickOutside && onClickOutside("par");
        }
        if (unrealRef?.current && !unrealRef?.current?.contains(event.target)) {
          onClickOutside && onClickOutside("unreal");
        }
      };
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    }, [onClickOutside]);

    const handleClick = (key) => {
      if (key === "par_value") {
        !parMenuOpen ? setParMenuOpen(true) : setParMenuOpen(false);
      } else if (key === "instrument_name") {
        !namesMenuOpen ? setNamesMenuOpen(true) : setNamesMenuOpen(false);
      } else {
        !unrealMenuOpen ? setUnrealMenuOpen(true) : setUnrealMenuOpen(false);
      }
    };
    const handleNifty = (data, index) => {
      handleSort(data.item.key);
      setSortingAnnoucement(
        `Table Sorted By ${data.item?.show} In ${
          data.isSortedAscending ? "Ascending" : "Descending"
        } Order `,
      );
    };
    return (
      <div
        className={
          sortable
            ? "header_cell cursor blueTextColor"
            : "header_cell blueTextColor"
        }
        onClick={() => handleClick(key)}
        ref={
          key === "par_value"
            ? parRef
            : key === "instrument_name"
              ? nameRef
              : unrealRef
        }
      >
        <PopupMenu2
          position={position}
          type="multiSort"
          open={
            key === "par_value"
              ? parMenuOpen
              : key === "instrument_name"
                ? namesMenuOpen
                : unrealMenuOpen
          }
          setOpen={
            key === "par_value"
              ? setParMenuOpen
              : key === "instrument_name"
                ? setNamesMenuOpen
                : setUnrealMenuOpen
          }
          ref={reff}
          MenuContent={() => (
            <SortFilterList
              list={multiSortBox}
              onClick={(data, index) => handleNifty(data, index)}
              title="Sort by"
              isAscending={isAscending}
              sortKey={sortKey}
              key={key}
            />
          )}
          headerLabel={headerLabel}
          buttonClass="header-custom-button"
        >
          <div
            style={{ display: "flex", gap: "4px" }}
            className="popupchild_div"
          >
            <p style={pWidth ? { maxWidth: pWidth } : {}} className="label1">
              {label}
            </p>
            <p style={pWidth ? { maxWidth: pWidth } : {}} className="label2">
              {label2}
            </p>
            {sortable && (
              <div
                className="accordion_table_header_child_icon"
                style={{ alignSelf: "center" }}
              >
                <img
                  aria-hidden={true}
                  src={
                    isAscending && forArrowCheckComp?.includes(sortKeyComp)
                      ? sortedIcon
                      : !isAscending && forArrowCheckComp?.includes(sortKeyComp)
                        ? sortedAtoz
                        : !forArrowCheckComp?.includes(sortKeyComp)
                          ? unsortedIcon
                          : unsortedIcon
                  }
                  alt="sort"
                />
              </div>
            )}
          </div>
        </PopupMenu2>
      </div>
    );
  };

  const headerRenderer = (
    {
      label,
      label2,
      key,
      sortable,
      width,
      minWidth,
      classn,
      customHeaderRenderer,
      isMultipleSort,
      multiSortBox,
      position,
      forArrowCheck,
      optionNum,
      pStyle,
      tdStyle,
      currentSortKey,
      pWidth,
      justifyContent,
      headerLabel,
    },
    index,
  ) => {
    if (customHeaderRenderer) {
      return customHeaderRenderer({
        label,
        key,
        sortable,
        width,
        minWidth,
        classn,
        optionNum,
        tdStyle,
        pStyle,
        currentSortKey,
      });
    } else {
      const getSortingAnnouncement = ({
        isMultipleSort,
        sortable,
        keyName,
        isAscending,
        sortKey,
        label,
      }) => {
        return isMultipleSort === undefined
          ? sortable
            ? keyName === sortKey
              ? isAscending
                ? "Ascending"
                : "Descending"
              : undefined
            : undefined
          : forArrowCheck?.includes(sortKey)
            ? isAscending
              ? "Ascending"
              : "Descending"
            : undefined;
      };

      return (
        <th
          aria-sort={getSortingAnnouncement({
            isMultipleSort,
            sortable,
            keyName: key,
            isAscending,
            sortKey,
            label,
          })}
          className={
            classn ? classn : index === 3 && forThirdTd ? forThirdTd : ""
          }
          style={{ width: width, minWidth: minWidth }}
        >
          {isMultipleSort === undefined ? (
            <TableHeading
              sortable={sortable}
              justifyContent={justifyContent}
              label={label}
              label2={label2}
              isAscending={isAscending}
              sortKey={sortKey}
              keyName={key}
              handleSort={() => {
                handleSort(key);
              }}
              headerLabel={headerLabel}
            />
          ) : (
            // <div
            //   style={justifyContent ? { justifyContent } : {}}
            //   className={sortable ? "header_cell cursor" : "header_cell"}
            //   aria-label={sortable ? `Sort by ${label}` : undefined}
            //   onClick={() => sortable && handleSort(key)}
            // >
            //   <>
            //     <p className="label1">{label}</p>
            //     {label2 && <p className="label2">{label2}</p>}
            //     {sortable && (
            //       <>
            //         <img
            //           src={
            //             isAscending && sortKey === key
            //               ? sortedIcon
            //               : !isAscending && sortKey === key
            //               ? sortedAtoz
            //               : sortKey !== key
            //               ? unsortedIcon
            //               : unsortedIcon
            //           }
            //           alt="sort"
            //         />
            //       </>
            //     )}
            //   </>
            // </div>
            <HeaderComp
              classn={classn}
              pWidth={pWidth}
              index={index}
              width={width}
              minWidth={minWidth}
              sortable={sortable}
              isMultipleSort={isMultipleSort}
              key={key}
              label={label}
              label2={label2}
              multiSortBox={multiSortBox}
              position={position}
              sortKeyComp={sortKey}
              forArrowCheckComp={forArrowCheck}
              headerLabel={headerLabel}
            />
          )}
        </th>
      );
    }
  };

  const getRowData = () => {
    return data;
  };

  useLayoutEffect(() => {
    if (
      columns?.[0]?.key !== "instrument_name" &&
      columns?.[0]?.label?.includes("Qty")
    ) {
      setIsOption4Col(true);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {(!!data && !!data.length) || showColumnsOnly ? (
        <>
          <table
            className={`table ${tableClass ? tableClass : "custom_table"} common-table`}
          >
            {tableCaption && <TableCaption captionName={tableCaption} />}
            <thead className={tableHeaderClass}>
              <tr>
                {!!data && !!data.length ? (
                  columns?.map(headerRenderer)
                ) : showColumnsOnly ? (
                  columns?.map(headerRenderer)
                ) : (
                  <>""</>
                )}
              </tr>
            </thead>

            <tbody>
              {(!showColumnsOnly || data) &&
                getRowData().map((eachRow, index) => {
                  return (
                    <tr
                      id={
                        !eachRow?.measure_instr_id
                          ? ""
                          : eachRow.measure_instr_id
                      }
                      className={`${
                        index === data?.length - 2 ? forBorderClass : ""
                      } ${data.length === 1 ? "single_row" : ""}`}
                    >
                      {columns.map((column, idx) => {
                        return (
                          <td
                            style={
                              classUnrealised && idx === columns.length - 4
                                ? { paddingRight: "5px" }
                                : isOption4Col &&
                                    idx === 0 &&
                                    eachRow?.actualWholeObject?.investmentreturn
                                      ?.commitment_val?.amount?.actual_value
                                  ? { padding: "15px 18px 30px 10px" }
                                  : eachRow?.actualWholeObject?.investmentreturn
                                        ?.commitment_val?.amount
                                        ?.actual_value && isOption4Col
                                    ? { paddingBottom: "30px" }
                                    : {}
                            }
                          >
                            {column.cellRenderer
                              ? column.cellRenderer(
                                  eachRow[column.key],
                                  eachRow,
                                  column.key,
                                  index,
                                )
                              : eachRow[column.key]}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              {elementToPush !== undefined &&
                elementToPush?.map((eachRow, index) => {
                  return (
                    <tr className="total_row">
                      {columns.map((column, idx) => {
                        return (
                          <td
                            id={
                              !eachRow.measure_instr_id
                                ? ""
                                : eachRow.measure_instr_id
                            }
                          >
                            {(idx === 0 || idx === 4 || idx === 6) &&
                            column.cellRenderer
                              ? column.cellRenderer(
                                  eachRow[column.key],
                                  eachRow,
                                  column.key,
                                  index,
                                  "total",
                                  index,
                                )
                              : ""}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
            {/* </span> */}
          </table>
          {showColumnsOnly &&
            (data === undefined || data.length === 0) &&
            !!EmptyStateBody &&
            EmptyStateBody}
        </>
      ) : EmptyState ? (
        <>{EmptyState}</>
      ) : (
        <></>
      )}
    </>
  );
};

export default memo(Table);
